import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ByteRestaurantSystem from "./components/ByteRestaurantSystem";
import "./index.css";

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-purple-50 via-white to-indigo-50">
      <div className="bg-white rounded-2xl shadow-lg p-10 border border-purple-100 text-center max-w-md">
        <h1 className="text-4xl font-bold text-purple-700 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          Página no encontrada
        </h2>
        <p className="text-gray-600 mb-6">
          La ruta que buscas no existe o fue movida.
        </p>
        <a
          href="/"
          className="inline-block px-6 py-2.5 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl font-semibold shadow-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-300"
        >
          Volver al inicio
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/restaurant" element={<ByteRestaurantSystem />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
